import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const InviteSubmitPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "InviteSubmitPopup" */ './View'),
  'popup'
);
